import React from 'react';
import { matchRoutes, Navigate, useLocation } from 'react-router';

import { authRoutes } from '~/routes';
import { appPaths, authPaths } from '~/routes/app-paths';
import { AppRoute } from '~/routes/Routes';
import { useAuthStore } from '~/stores/use-auth/store/authStore';
import { ServerError } from '~/views/error';

import { ErrorBoundaryWrapper } from '../error-boundary-wrapper/ErrorBoundaryWrapper';
import { View } from './view/View';

export interface ProtectedRouteProps {
  config: AppRoute;
}

export const ProtectedView = ({ config }: ProtectedRouteProps) => {
  const location = useLocation();
  const isAuthenticated = useAuthStore(state => !!state.token);
  const isAuthRoute = matchRoutes(authRoutes, location);

  if (!isAuthenticated) {
    return isAuthRoute ? (
      config.element
    ) : (
      <Navigate to={authPaths.login} replace />
    );
  }

  if (isAuthRoute) {
    return <Navigate to={appPaths.base} replace />;
  }

  return (
    <ErrorBoundaryWrapper fallback={<ServerError />}>
      <View config={config} />
    </ErrorBoundaryWrapper>
  );
};
